import {connect} from 'react-redux'
import Audio from '../components/Audio.jsx'
import {
  updateCurrentTime,
  updateDuration,
  playNext,
  mute
} from '../../../actions/Actions.js'

// Map Redux state to component props
function mapStateToProps (state) {
  return {
    playback: state.radio.playback,
    track: state.radio.tracks[state.radio.track],
    currentTime: state.radio.currentTime,
    muted: state.radio.mute,
    scrubbing: state.radio.scrubbing
  }
}

// Map Redux actions to component props
function mapDispatchToProps (dispatch) {
  return {
    onMute: () => dispatch(mute()),
    onEnd: () => dispatch(playNext()),
    onUpdateCurrentTime: (time) => dispatch(updateCurrentTime(time)),
    onUpdateDuration: (time) => dispatch(updateDuration(time))
  }
}

// Connected Component
const AudioContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(Audio)

export default AudioContainer
